import React from 'react'
import PropTypes from 'prop-types'

const OutboundProductReference = ({ product }) => {
  const inventoryId = product.inventory && product.inventory.id
  if (!inventoryId) return <>{ product.sku || '-' } — { product.name || '-' }</>
  const href = `/app/warehouse-team/inventory/${inventoryId}`
  return <>
    <a href={ href } target='_blank' rel='noopener noreferrer'>{ product.sku || '-' }</a>
    {' — '}
    <a href={ href } target='_blank' rel='noopener noreferrer'>{ product.name || '-' }</a>
  </>
}
OutboundProductReference.propTypes = { product: PropTypes.object.isRequired }
export default OutboundProductReference
